module.exports = __webpack_public_path__ + "media/img/illustrations/eye-shape-dark-25007d1c5238d6a217797ddafeda7d71.svg";